import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import './config/i18n';
import './style/login.css'
import './style/rtl_css/login.css'
//REDUX
import {applyMiddleware, createStore } from 'redux';
import { I18nextProvider } from "react-i18next";
import i18n from "./config/i18n";

import reducer from './redux/reducers/index.js'
import {Provider} from "react-redux";
const store = createStore(reducer, /*applyMiddleware(logger)*/);

if(process.env.REACT_APP_ENV==='production'/*||process.env.REACT_APP_ENV==='staging'*/){
    console.log =()=>{}
}

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
{/*      <React.StrictMode>
        <App />
      </React.StrictMode>*/}
        <App />

    </Provider>
  </I18nextProvider>
  , document.getElementById('root')
);

let list = document.getElementsByClassName("btn-primary");
for (let index = 0; index < list.length; ++index) {
  list[index].setAttribute("tabIndex", "-1");
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
